import { z } from 'zod';

const schema = z.object({
  VITE_API_URL: z.url(),
  VITE_APP_NAME: z.string().default('NT App'),
  // `z.stringbool()` aceita 'true'/'false'/'1'/'0'/'yes'/'no'/'on'/'off' e
  // devolve boolean. NÃO usar `z.coerce.boolean()` aqui: ele aplica
  // `Boolean(string)`, que converte qualquer string não-vazia (incluindo
  // 'false') para `true` — pegadinha clássica com env vars.
  VITE_DEV_IMPERSONATION_ENABLED: z.stringbool().default(false),
  VITE_SENTRY_DSN: z.string().optional(),
  // Métodos de login exibidos. SSO Microsoft é o padrão; o form email/senha é
  // opt-in (LDAP em produção ou usuários de teste em local/QA). Devem espelhar
  // `AZURE_AD_ENABLED`, `AUTH_LOCAL_ENABLED` e `AUTH_LDAP_ENABLED` do backend.
  VITE_AZURE_SSO_ENABLED: z.stringbool().default(true),
  VITE_PASSWORD_LOGIN_ENABLED: z.stringbool().default(false),
});

const parsed = schema.safeParse(import.meta.env);
if (!parsed.success) {
  console.error('❌ Invalid env:', z.treeifyError(parsed.error));
  throw new Error('Invalid environment variables');
}

export const env = parsed.data;

export const isDev = import.meta.env.DEV;
